<div class="stepper-body">
    <div class="body-title">
        <span>Where are you in the homebuying process?</span>
    </div>
    <div class="body-description">
        <span>Select all that apply.</span>
    </div>
    <div class="body-answers custom-answers">
        <div class="custom-container">
            <button mat-stroked-button class="step-option" [ngClass]="{
                            'selected':isBtnSelected(HomebuyingStatusOptions.PurchaseContract)
                        }" (click)="onAnswerSelected(HomebuyingStatusOptions.PurchaseContract)">
                {{HomebuyingStatusOptions.PurchaseContract}}
            </button>
        </div>
        <div class="custom-container">
            <button mat-stroked-button class="step-option" [ngClass]="{
                            'selected':isBtnSelected(HomebuyingStatusOptions.MakingOffers)
                        }" (click)="onAnswerSelected(HomebuyingStatusOptions.MakingOffers)">
                {{HomebuyingStatusOptions.MakingOffers}}
            </button>
        </div>
        <div class="custom-container">
            <button mat-stroked-button class="step-option" [ngClass]="{
                            'selected':isBtnSelected(HomebuyingStatusOptions.PreApproval)
                        }" (click)="onAnswerSelected(HomebuyingStatusOptions.PreApproval)">
                {{HomebuyingStatusOptions.PreApproval}}
            </button>
        </div>
        <div class="custom-container">
            <button mat-stroked-button class="step-option" [ngClass]="{
                            'selected':isBtnSelected(HomebuyingStatusOptions.LookingRates)
                        }" (click)="onAnswerSelected(HomebuyingStatusOptions.LookingRates)">
                {{HomebuyingStatusOptions.LookingRates}}
            </button>
        </div>
    </div>
</div>
<div class="stepper-footer">
    <mat-divider></mat-divider>
    <div class="step-controls">
        <button [style.visibility]="!isDialog && prepopulatedPurpose  ? 'hidden' : 'visible'" mat-stroked-button color="primary" (click)="onBack()" class="step-button secondary" [disabled]="false">
            {{ prepopulatedPurpose ? 'Close' : 'Back' }}
        </button>
        <button mat-flat-button color="primary" (click)="onNext()" class="step-button primary" [disabled]="isNextDisabled()">
            Next
        </button>
    </div>
</div>